// extracted by mini-css-extract-plugin
export var wrapper = "Footer-module--wrapper--2H_Xw";
export var text = "Footer-module--text--2PaAk";